<template>
  <div class="zip-file-download">
    <div v-if="somePartsCurrentlyRetouching">
      <contentful-text :item="contentfulText('checkout-download-photos-retouching-in-progress')" />
    </div>
    <div
      v-if="!somePartsCurrentlyRetouching"
      class="row"
    >
      <div class="col-xs-12 col-sm-3">
        <a
          :href="viewModel.MediumImagesZipUrl"
          target="_blank"
          class="button zip-file-download__button"
          @click="trackClick('Medium')"
        >
          <contentful-text
            :item="contentfulText('checkout-download-photos-download-all-label')"
            class="zip-file-download__button-label--uppercase"
          />
          ({{ contentfulText('checkout-download-photos-image-size-medium').Content }})
        </a>
      </div>
      <div v-if="viewModel.FullSizedDownloadEntitled && viewModel.IsTLHAvailable">
        <div
          v-if="viewModel.AllPartsHaveFull"
          class="col-xs-12 col-sm-3"
        >
          <a
            :href="viewModel.LargeImagesZipUrl"
            target="_blank"
            class="button zip-file-download__button"
            @click="trackClick('Large')"
          >
            <contentful-text
              :item="contentfulText('checkout-download-photos-download-all-label')"
              class="zip-file-download__button-label--uppercase"
            />
            ({{ contentfulText('checkout-download-photos-image-size-large').Content }})
          </a>
        </div>
        <div
          v-if="viewModel.AllowXLarge"
          class="col-xs-12 col-sm-3"
        >
          <div v-if="viewModel.AllPartsHaveFull">
            <a
              :href="viewModel.XLargeImagesZipUrl"
              target="_blank"
              class="button zip-file-download__button"
              @click="trackClick('XLarge')"
            >
              <contentful-text
                :item="contentfulText('checkout-download-photos-download-all-label')"
                class="zip-file-download__button-label--uppercase"
              />
              ({{ contentfulText('checkout-download-photos-image-size-xlarge').Content }})
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'ZipFileDownload',
  computed: {
    viewModel () {
      return this.$store.state.viewModel
    },
    somePartsCurrentlyRetouching () {
      return this.$store.getters.somePartsCurrentlyRetouching
    },
    content () {
      return this.viewModel.PageContent
    }
  },
  methods: {
    trackClick (size) {
      GoogleAnalytics.trackEvent(
        'DigitalImageDownload',
        'Zip',
        size
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.zip-file-download {
  margin: 20px 0;

  &__button {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    text-transform: none;
    width: 100%;

    &-label {
      &--uppercase {
        text-transform: uppercase;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/Photos/ZipFileDownload.vue